import { useEffect, ReactNode, RefObject } from 'react';

export function useUpdatePromoTitleHeights(
    layoutReference: RefObject<HTMLDivElement>,
    content: ReactNode[],
    isCardLayout = true,
): void {
    useEffect(() => {
        if (!isCardLayout || !layoutReference.current || content.length < 2) {
            return;
        }

        // eslint-disable-next-line unicorn/prefer-spread
        const titles = Array.from(
            layoutReference.current.querySelectorAll<HTMLElement>(
                '[data-sub-head]',
            ),
        );

        function updateHeights() {
            titles.forEach(element => (element.style.minHeight = ''));

            const gridTop =
                layoutReference.current!.getBoundingClientRect().top;

            const rows = titles.reduce<Record<number, HTMLElement[]>>(
                (accumulator, element) => {
                    const y = Math.round(
                        element.getBoundingClientRect().top - gridTop,
                    );
                    accumulator[y] = accumulator[y] || [];
                    accumulator[y].push(element);
                    return accumulator;
                },
                {},
            );

            Object.values(rows).forEach(rowEls => {
                let maxH = 0;
                rowEls.forEach(element => {
                    const h = element.getBoundingClientRect().height;
                    if (h > maxH) maxH = h;
                });
                rowEls.forEach(element => {
                    element.style.minHeight = `${maxH}px`;
                });
            });
        }

        let observer: ResizeObserver | null = null;
        if (typeof ResizeObserver !== 'undefined') {
            observer = new ResizeObserver(updateHeights);
            titles.forEach(element => observer!.observe(element));
        } else {
            window.addEventListener('resize', updateHeights);
        }

        return () => {
            if (observer) {
                observer.disconnect();
            } else {
                window.removeEventListener('resize', updateHeights);
            }
        };
    }, [content, isCardLayout, layoutReference]);
}
